<template>
  <div>
    <populate-form
      formTitle="例外休息時段規則設定"
      fkey="pe01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <b-table
      stacked="sm"
      :items="restTimeRules"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button @click="removeRestTimeRule(row.item.id)">刪除</b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowAdd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="新增自訂休息時段規則"
        fkey="arf01"
        ref="addForm2"
        :parentVue="this"
        populateOptionVar="addOptions"
        formDataObjVar="addData"
      ></populate-form>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: 'StoreRestTimeRuleManage',
  components:{
    
  },
  props: {
    
  },
  data: function () {
    return {
      modalShowAdd:false,
      service_minute_unit:30,
      restTimeRules:[],
      fields:[
        {
          key:'display',
          label:'規則'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'b-button',
          col:3,
          placeholder:"新增",
          execCallback:this.showAddRule
        },
      ],
      addData:{},
      addOptions:[
        {
          componentType:'b-form-select',
          akey:'nth_weekday',
          dataOptions:[{text:'每週',value:'0'},{text:'每個月第一個',value:'1'},{text:'每個月第二個',value:'2'},{text:'每個月第三個',value:'3'},{text:'每個月第四個',value:'4'}],
          defaultValue:'0',
          col:3,
        },
        {
          componentType:'b-form-select',
          akey:'week_day',
          dataOptions:[{text:'週日',value:'0'},{text:'週一',value:'1'},{text:'週二',value:'2'},{text:'週三',value:'3'},{text:'週四',value:'4'},{text:'週五',value:'5'},{text:'週六',value:'ˊ6'}],
          defaultValue:'0',
          col:3,
        },
        {
          componentType:'vue-timepicker',
          col:3,
          akey:'no_service_start',
          placeholder:"停止服務開始時間",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'vue-timepicker',
          col:3,
          akey:'no_service_end',
          placeholder:"停止服務結束時間",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.modalShowAdd = false}
            },
            {
              col:4,
              placeholder:'確認',
              execCallback:this.confirmAdd
            },
          ]
        },
      ],
    }
  },
  methods: {
    showAddRule() {
      this.addData.nth_weekday = ''
      this.addData.week_day = ''
      this.addData.no_service_start = ''
      this.addData.no_service_end = ''
      this.$refs.addForm2.refreshModelVar()
      
      //this.$refs.addForm2.initDefault()
      this.modalShowAdd = true
    },
    removeRestTimeRule(id) {
      this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
        let Param = {
          'module':'store',
          'method':'removeStoreRestTimeRule',
          'store_id': this.$bus.session.merchant_store_id,
          'rule_id':id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (!data.data.confirm_remove) {
                vm.$bus.fnClosePopup()
                vm.$bus.fnShowInfo(data.msg)
                return
              }
            }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.searchRestRules()
        }, this)
      })
    },
    searchRestRules() {
      let Param = {
        'module':'store',
        'method':'getStoreRestTimeRules',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.restTimeRules =data.data
      }, this)
    },
    confirmAdd() {
      if (!this.addData.no_service_start || !this.addData.no_service_end) {
        this.$refs.addForm2.triggerAlert('規則的休息起訖時間未選擇完成')
        return
      }
      if (this.addData.no_service_start > this.addData.no_service_end) {
        this.$refs.addForm2.triggerAlert('休息時間起訖錯誤')
        return
      }
      let Param = {
        'module':'store',
        'method':'addStoreRestTimeRule',
        'store_id': this.$bus.session.merchant_store_id,
        'nth_weekday':this.addData.nth_weekday,
        'week_day':this.addData.week_day,
        'no_service_start':this.addData.no_service_start,
        'no_service_end':this.addData.no_service_end,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchRestRules()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("添加設定成功")
        vm.modalShowAdd = false
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.searchRestRules()
      this.addOptions[2].minuteInterval = this.service_minute_unit
      this.addOptions[3].minuteInterval = this.service_minute_unit
      this.$refs.addForm2.initDefault()
      
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
